import api from "./api";
import { Tag, Category } from "@/types";

// ============ Tags ============
// Get all tags
export const fetchTags = async (): Promise<Tag[]> => {
  return api.get("/tags");
};

// Get popular tags
export const fetchPopularTags = async (limit: number = 10): Promise<Tag[]> => {
  return api.get(`/tags/popular?limit=${limit}`);
};

// Get tag by slug
export const fetchTagBySlug = async (slug: string): Promise<Tag> => {
  return api.get(`/tags/${slug}`);
};

// Create new tag
export const createTag = async (tagData: Partial<Tag>): Promise<Tag> => {
  return api.post("/tags", tagData);
};

// Update tag
export const updateTag = async (
  tagId: string,
  tagData: Partial<Tag>
): Promise<Tag> => {
  return api.put(`/tags/${tagId}`, tagData);
};

// Delete tag
export const deleteTag = async (tagId: string): Promise<void> => {
  return api.delete(`/tags/${tagId}`);
};

// Search tags
export const searchTags = async (query: string): Promise<Tag[]> => {
  return api.get(`/tags/search?q=${encodeURIComponent(query)}`);
};

// ============ Categories ============
// Get all categories
export const fetchCategories = async (): Promise<Category[]> => {
  return api.get("/categories");
};

// Get category by slug
export const fetchCategoryBySlug = async (slug: string): Promise<Category> => {
  return api.get(`/categories/${slug}`);
};

// Create new category
export const createCategory = async (
  categoryData: Partial<Category>
): Promise<Category> => {
  return api.post("/categories", categoryData);
};

// Update category
export const updateCategory = async (
  categoryId: string,
  categoryData: Partial<Category>
): Promise<Category> => {
  return api.put(`/categories/${categoryId}`, categoryData);
};

// Delete category
export const deleteCategory = async (categoryId: string): Promise<void> => {
  return api.delete(`/categories/${categoryId}`);
};

// Get category statistics
export const fetchCategoryStats = async (): Promise<
  {
    category: Category;
    postCount: number;
    activeUsers: number;
  }[]
> => {
  return api.get("/categories/stats");
};
